import { useEffect, useState } from "react";
import { Menu, X, Nfc } from "lucide-react";
import { Button } from "../ui/button";

const links = [
    { label: "Get a quote", href: "#top" },
    { label: "Explore", href: "#explore" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        onScroll();
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-navbar"
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "bg-black/60 backdrop-blur-xl border-b border-white/10"
                    : "bg-transparent border-b border-transparent"
            }`}
        >
            <nav className="max-w-7xl mx-auto px-6 sm:px-10 h-16 flex items-center justify-between">
                <a
                    href="#top"
                    data-testid="nav-logo"
                    className="flex items-center gap-2 group"
                >
                    <span className="w-8 h-8 rounded-lg bg-blue-600/20 border border-blue-500/40 flex items-center justify-center group-hover:bg-blue-600/30 transition-colors">
                        <Nfc className="w-4 h-4 text-blue-400" strokeWidth={1.8} />
                    </span>
                    <span className="font-display text-lg font-medium tracking-tight">
                        NFC<span className="text-blue-500">Pro</span>
                    </span>
                </a>

                <div className="hidden md:flex items-center gap-8">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.href.replace("#", "")}`}
                            className="text-sm text-zinc-400 hover:text-white transition-colors"
                        >
                            {l.label}
                        </a>
                    ))}
                </div>

                <div className="hidden md:block">
                    <a href="#top">
                        <Button
                            data-testid="nav-cta-get-started"
                            className="rounded-full bg-blue-600 hover:bg-blue-500 text-white px-5 h-10 shadow-[0_0_30px_rgba(37,99,235,0.35)]"
                        >
                            Get a Quote
                        </Button>
                    </a>
                </div>

                <button
                    data-testid="nav-mobile-toggle"
                    className="md:hidden w-10 h-10 rounded-md border border-white/10 flex items-center justify-center"
                    onClick={() => setOpen((o) => !o)}
                    aria-label="Toggle menu"
                >
                    {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                </button>
            </nav>

            {open && (
                <div
                    data-testid="nav-mobile-panel"
                    className="md:hidden border-t border-white/10 bg-black/90 backdrop-blur-xl"
                >
                    <div className="px-6 py-4 flex flex-col gap-3">
                        {links.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={() => setOpen(false)}
                                data-testid={`nav-mobile-link-${l.href.replace("#", "")}`}
                                className="py-2 text-zinc-300 hover:text-white"
                            >
                                {l.label}
                            </a>
                        ))}
                        <a href="#top" onClick={() => setOpen(false)}>
                            <Button
                                data-testid="nav-mobile-cta"
                                className="w-full rounded-full bg-blue-600 hover:bg-blue-500"
                            >
                                Get a Quote
                            </Button>
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
}
